<template>
    <div class="page" style="display: flex;flex-direction: row">
        <div style="flex: 1" class="pj">
            <el-form
                :model="eduExercise"
                ref="eduExerciseForm"
                :rules="rules"
                style="width: 100%"
                label-width="80px"
                size="small"
            >
                <el-form-item
                    label="题干"
                    prop="exerciseName"
                >
                    <div style="width: 100%;">
                        <WangEditor key="wangeditor1" style="width: 100%;" :height="'150px'" ref="contentEditor" :disabled="eduExerciseState" v-model="eduExercise.exerciseName" />
                    </div>
                </el-form-item>
                <el-form-item
                    label="题目分类"
                    prop="categoryId"
                >
                    <el-select
                        clearable
                        style="width: 100%"
                        v-model="eduExercise.categoryId"
                        :disabled="eduExerciseState == 'check'"
                        placeholder="请选择"
                        size="small"
                    >
                        <el-tree
                            :data="CategoryList"
                            :props="treeProps"
                            :render-after-expand="false"
                        >
                            <div
                                class="custom-tree-node flex items-center"
                                slot-scope="{ node, data }"
                            >
                                <el-option
                                    :label="node.label"
                                    :value="data.id"
                                > </el-option>
                            </div>
                        </el-tree>
                    </el-select>
                </el-form-item>
<!--                <el-form-item-->
<!--                    label="题目类型"-->
<!--                    prop="exerciseType"-->
<!--                >-->
<!--                    <el-select :disabled="eduExerciseState == 'check'" style="width: 100%" v-model="eduExercise.exerciseType" placeholder="请选择题目类型">-->
<!--                        <el-option-->
<!--                            v-for="item in videoLocationList"-->
<!--                            :key="item.value"-->
<!--                            :label="item.value"-->
<!--                            :value="item.key"-->
<!--                        ></el-option>-->
<!--                    </el-select>-->
<!--                </el-form-item>-->
<!--                <el-form-item-->
<!--                    label="选项内容"-->
<!--                    prop="optionContent"-->
<!--                    v-if="eduExercise.exerciseType < 3"-->
<!--                >-->
<!--                    <div v-if="eduExercise.exerciseType == 1 || eduExercise.exerciseType == 2" style="margin: 0 0 18px;width: 100%;display: flex;justify-content: space-between;" v-for="(eduExerciseChoice, index) in radioList" :key="index">-->
<!--                        <el-input-->
<!--                            style="width: 80%;"-->
<!--                            size="small"-->
<!--                            v-model="eduExerciseChoice.optionContent"-->
<!--                            :disabled="eduExerciseState == 'check'"-->
<!--                        ></el-input>-->
<!--                        <div @click="addcheck('radio')" v-if="index == 0" style="margin-right: 1%;cursor: pointer; width: 32px;height: 32px;border-radius: 16px;background-color: #2d8cf0;font-size: 20px;color: #fff;display: flex;justify-content: center;align-items: center">-->
<!--                            +-->
<!--                        </div>-->
<!--                        <div @click="subcheck('radio', index)" v-if="index > 2" style="margin-right: 1%;cursor:pointer; width: 32px;height: 32px;border-radius: 16px;background-color: #be2222;font-size: 20px;color: #fff;display: flex;justify-content: center;align-items: center">-->
<!--                            - -->
<!--                        </div>-->
<!--                    </div>-->
<!--                </el-form-item>-->
<!--                <el-form-item-->
<!--                    label="选项答案"-->
<!--                    prop="option"-->
<!--                >-->
<!--                    <el-radio-group v-if="eduExercise.exerciseType == 1" v-model="radio">-->
<!--                        <el-radio-button v-for="(eduExerciseChoice, index) in radioList" :label="eduExerciseChoice.option" :key="index">{{eduExerciseChoice.option}}</el-radio-button>-->
<!--                    </el-radio-group>-->
<!--                    <el-checkbox-group v-if="eduExercise.exerciseType == 2" v-model="radio">-->
<!--                        <el-checkbox-button v-for="(eduExerciseChoice, index) in radioList" :label="eduExerciseChoice.option" :key="index">{{eduExerciseChoice.option}}</el-checkbox-button>-->
<!--                    </el-checkbox-group>-->
<!--                    <el-radio-group v-if="eduExercise.exerciseType == 3" v-model="judge.judge">-->
<!--                        <el-radio-button :label="1">正确</el-radio-button>-->
<!--                        <el-radio-button :label="0">错误</el-radio-button>-->
<!--                    </el-radio-group>-->
<!--                    <div style="margin: 0 0 18px;width: 100%;display: flex;justify-content: space-between;" v-for="(fill, index) in fillList" v-if="eduExercise.exerciseType == 4">-->
<!--                        <el-input-->
<!--                            style="width: 80%;"-->
<!--                            size="small"-->
<!--                            v-model="fill.fillContent"-->
<!--                            :placeholder="'请填写第'+ fill.fillSeq + '空答案'"-->
<!--                            :disabled="eduExerciseState == 'check'"-->
<!--                        ></el-input>-->
<!--                        <div @click="addcheck('fill')" v-if="index == 0" style="cursor: pointer;width: 32px;height: 32px;border-radius: 16px;background-color: #2d8cf0;font-size: 20px;color: #fff;display: flex;justify-content: center;align-items: center">-->
<!--                            +-->
<!--                        </div>-->
<!--                        <div @click="subcheck('fill', index)" v-if="index != 0" style="cursor: pointer;width: 32px;height: 32px;border-radius: 16px;background-color: #be2222;font-size: 20px;color: #fff;display: flex;justify-content: center;align-items: center">-->
<!--                            - -->
<!--                        </div>-->
<!--                    </div>-->
<!--                    <el-input-->
<!--                        size="small"-->
<!--                        v-if="eduExercise.exerciseType == 5"-->
<!--                        v-model="replyContent"-->
<!--                        :disabled="eduExerciseState == 'check'"-->
<!--                    ></el-input>-->
<!--                </el-form-item>-->
                <el-form-item
                    label="难度程度"
                    prop="difficulty"
                >
                    <el-select :disabled="eduExerciseState == 'check'" style="width: 100%" v-model="eduExercise.difficulty" placeholder="请选择难度程度">
                        <el-option
                            v-for="item in startCount"
                            :key="item.value"
                            :label="item.value"
                            :value="item.key"
                        ></el-option>
                    </el-select>
                </el-form-item>
<!--                <el-form-item-->
<!--                    label="解析"-->
<!--                    prop="analysis"-->
<!--                >-->
<!--                    <div style="width: 80%;">-->
<!--                        <WangEditor style="width: 100%;" :height="'200px'" ref="contentEditor1" :disabled="eduExerciseState" v-model="eduExercise.analysis" />-->
<!--                    </div>-->
<!--                </el-form-item>-->
                <el-form-item
                    label="所属科目"
                    prop="subjectId"
                >
                    <el-select
                        clearable
                        style="width: 100%"
                        :disabled="eduExerciseState == 'check'"
                        v-model="eduExercise.subjectId"
                        placeholder="请选择"
                        size="small"
                    >
                        <el-tree
                            :data="eduSubjectList"
                            :props="treeProps2"
                            :render-after-expand="false"
                        >
                            <div
                                class="custom-tree-node flex items-center"
                                slot-scope="{ node, data }"
                            >
                                <el-option
                                    :label="node.label"
                                    :value="data.id"
                                > </el-option>
                            </div>
                        </el-tree>
                    </el-select>
                </el-form-item>
                <el-form-item
                    label="知识点"
                    prop="knowledgeIds"
                >
                    <div style="display: flex">
                        <GridSelectU ref="gridSelectU1" style="flex: 1" :rowCount="2" :isClick="true" title="选择知识点" labelName="knowledgeName"
                                     labelValue="id" :value="eduExercise.knowledgeIds" :limit='99' size='small' placeholder='请选择知识点'
                                     @getValue="getUser" :columns="EDUKNOWLEDGE_code" :searchs="EDUKNOWLEDGE_search" dataListUrl="/edu/knowledge/findList" entityBeanName="eduKnowledge" queryEntityUrl="/edu/knowledge/get">
                        </GridSelectU>
                        <el-button style="width: 100px;margin-left: 10px" type="primary" size="small" @click="addKnowledge">选择知识点</el-button>
                    </div>
                </el-form-item>
                <el-form-item
                    label="解析"
                    prop="analysis"
                >
                    <div style="width: 100%;">
                        <WangEditor key="wangeditor2" style="width: 100%;" :height="'150px'" ref="contentEditor1" :disabled="eduExerciseState" v-model="eduExercise.analysis" />
                    </div>
                </el-form-item>
            </el-form>
        </div>













        <div style="flex: 1;margin-left: 30px;height: 100%" class="pj">
            <el-form
                :model="eduExercise"
                ref="eduExerciseForm1"
                :rules="rules"
                style="width: 100%"
                label-width="80px"
                size="small"
            >
<!--                <el-form-item-->
<!--                    label="科目"-->
<!--                    prop="subjectId"-->
<!--                >-->
<!--                    <el-select-->
<!--                        clearable-->
<!--                        style="width: 50%"-->
<!--                        :disabled="eduExerciseState == 'check'"-->
<!--                        v-model="eduExercise.subjectId"-->
<!--                        placeholder="请选择"-->
<!--                        size="small"-->
<!--                    >-->
<!--                        <el-tree-->
<!--                            :data="eduSubjectList"-->
<!--                            :props="treeProps2"-->
<!--                            :render-after-expand="false"-->
<!--                        >-->
<!--                            <div-->
<!--                                class="custom-tree-node flex items-center"-->
<!--                                slot-scope="{ node, data }"-->
<!--                            >-->
<!--                                <el-option-->
<!--                                    :label="node.label"-->
<!--                                    :value="data.id"-->
<!--                                > </el-option>-->
<!--                            </div>-->
<!--                        </el-tree>-->
<!--                    </el-select>-->
<!--                </el-form-item>-->
<!--                <el-form-item-->
<!--                    label="题目分类"-->
<!--                    prop="categoryId"-->
<!--                >-->
<!--                    <el-select-->
<!--                        clearable-->
<!--                        style="width: 100%"-->
<!--                        v-model="eduExercise.categoryId"-->
<!--                        :disabled="eduExerciseState == 'check'"-->
<!--                        placeholder="请选择"-->
<!--                        size="small"-->
<!--                    >-->
<!--                        <el-tree-->
<!--                            :data="CategoryList"-->
<!--                            :props="treeProps"-->
<!--                            :render-after-expand="false"-->
<!--                        >-->
<!--                            <div-->
<!--                                class="custom-tree-node flex items-center"-->
<!--                                slot-scope="{ node, data }"-->
<!--                            >-->
<!--                                <el-option-->
<!--                                    :label="node.label"-->
<!--                                    :value="data.id"-->
<!--                                > </el-option>-->
<!--                            </div>-->
<!--                        </el-tree>-->
<!--                    </el-select>-->
<!--                </el-form-item>-->
                <el-form-item
                    label="题目类型"
                    prop="exerciseType"
                >
                    <el-select :disabled="eduExerciseState != 'add'" style="width: 90%" v-model="eduExercise.exerciseType" placeholder="请选择题目类型">
                        <el-option
                            v-for="item in videoLocationList"
                            :key="item.value"
                            :label="item.value"
                            :value="item.key"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item
                    label="选项内容"
                    prop="optionContent"
                    class="option-items"
                    v-if="eduExercise.exerciseType < 3"
                >
                    <div v-if="eduExercise.exerciseType == 1 || eduExercise.exerciseType == 2" style="height: 80%;margin: 0 0 18px;width: 100%;display: flex;justify-content: space-between;" v-for="(eduExerciseChoice, index) in radioList" :key="index">
                        <div style="width: 90%;display: flex">
                            {{eduExerciseChoice.option}}、
<!--                            <el-input-->
<!--                                size="small"-->
<!--                                style="flex: 1;margin-left: 10px"-->
<!--                                v-model="eduExerciseChoice.optionContent"-->
<!--                                :disabled="eduExerciseState == 'check'"-->
<!--                            ></el-input>-->
                            <WangEditor key="index" :ref="'choices' + index" style="flex: 1;margin-left: 10px" :height="'150px'" :disabled="eduExerciseState" v-model="eduExerciseChoice.optionContent" />
                        </div>
                        <div @click="addcheck('radio')" v-if="index == 0 && eduExerciseState == 'add'" style="margin-right: 1%;cursor: pointer; width: 32px;height: 32px;border-radius: 16px;background-color: #2d8cf0;font-size: 20px;color: #fff;display: flex;justify-content: center;align-items: center">
                            +
                        </div>
                        <div @click="subcheck('radio', index)" v-if="index > 1 && eduExerciseState == 'add'" style="margin-right: 1%;cursor:pointer; width: 32px;height: 32px;border-radius: 16px;background-color: #be2222;font-size: 20px;color: #fff;display: flex;justify-content: center;align-items: center">
                            -
                        </div>
                    </div>
                </el-form-item>
                <el-form-item
                    label="题目答案"
                    prop="option"
                >
                    <el-radio-group v-if="eduExercise.exerciseType == 1" v-model="radio">
                        <el-radio-button v-for="(eduExerciseChoice, index) in radioList" :label="eduExerciseChoice.option" :key="index">{{eduExerciseChoice.option}}</el-radio-button>
                    </el-radio-group>
                    <el-checkbox-group v-if="eduExercise.exerciseType == 2" v-model="radio">
                        <el-checkbox-button v-for="(eduExerciseChoice, index) in radioList" :label="eduExerciseChoice.option" :key="index">{{eduExerciseChoice.option}}</el-checkbox-button>
                    </el-checkbox-group>
                    <el-radio-group v-if="eduExercise.exerciseType == 3" v-model="judge.judge">
                        <el-radio-button :label="1">正确</el-radio-button>
                        <el-radio-button :label="0">错误</el-radio-button>
                    </el-radio-group>
                    <div style="margin: 0 0 18px;width: 100%;display: flex;justify-content: space-between;height: auto" v-for="(fill, index) in fillList" v-if="eduExercise.exerciseType == 4">
<!--                        <el-input-->
<!--                            style="width: 80%;"-->
<!--                            size="small"-->
<!--                            v-model="fill.fillContent"-->
<!--                            :placeholder="'请填写第'+ fill.fillSeq + '空答案'"-->
<!--                            :disabled="eduExerciseState == 'check'"-->
<!--                        ></el-input>-->
                        <div style="width: 90%;display: flex">
                            {{fill.fillSeq}}、
                            <!--                            <el-input-->
                            <!--                                size="small"-->
                            <!--                                style="flex: 1;margin-left: 10px"-->
                            <!--                                v-model="eduExerciseChoice.optionContent"-->
                            <!--                                :disabled="eduExerciseState == 'check'"-->
                            <!--                            ></el-input>-->
                            <WangEditor key="index" :ref="'fills' + index" style="flex: 1;margin-left: 10px" :height="'150px'" :disabled="eduExerciseState" v-model="fill.fillContent" />
                        </div>
                        <div @click="addcheck('fill')" v-if="index == 0" style="cursor: pointer;width: 32px;height: 32px;border-radius: 16px;background-color: #2d8cf0;font-size: 20px;color: #fff;display: flex;justify-content: center;align-items: center">
                            +
                        </div>
                        <div @click="subcheck('fill', index)" v-if="index != 0" style="cursor: pointer;width: 32px;height: 32px;border-radius: 16px;background-color: #be2222;font-size: 20px;color: #fff;display: flex;justify-content: center;align-items: center">
                            -
                        </div>
                    </div>
<!--                    <el-input-->
<!--                        size="small"-->
<!--                        v-if="eduExercise.exerciseType == 5"-->
<!--                        v-model="replyContent"-->
<!--                        :disabled="eduExerciseState == 'check'"-->
<!--                    ></el-input>-->
                    <div v-if="eduExercise.exerciseType == 5">
<!--                        <WangEditor key="index" ref="reply" style="width: 100%;height: 150px" :disabled="eduExerciseState" v-model="replyContent" />-->
                        <WangEditor ref="reply" style="width: 100%" :height="'150px'" :disabled="eduExerciseState" v-model="replyContent" />
                    </div>
                </el-form-item>
<!--                <el-form-item-->
<!--                    label="难度程度"-->
<!--                    prop="difficulty"-->
<!--                >-->
<!--                    <el-select :disabled="eduExerciseState == 'check'" style="width: 100%" v-model="eduExercise.difficulty" placeholder="请选择难度程度">-->
<!--                        <el-option-->
<!--                            v-for="item in startCount"-->
<!--                            :key="item.value"-->
<!--                            :label="item.value"-->
<!--                            :value="item.key"-->
<!--                        ></el-option>-->
<!--                    </el-select>-->
<!--                </el-form-item>-->
<!--                <el-form-item-->
<!--                    label="知识点"-->
<!--                    prop="knowledgeIds"-->
<!--                >-->
<!--                    <GridSelectU style="width: 100%;" title="选择知识点" labelName="knowledgeName" :disabled="eduExerciseState == 'check'"-->
<!--                                 labelValue="id" :value="eduExercise.knowledgeIds" :limit='99' size='small' placeholder='请选择知识点'-->
<!--                                 @getValue="getUser" :columns="EDUKNOWLEDGE_code" :searchs="EDUKNOWLEDGE_search" dataListUrl="/edu/knowledge/findList" entityBeanName="eduKnowledge" queryEntityUrl="/edu/knowledge/get">-->
<!--                    </GridSelectU>-->
<!--                </el-form-item>-->
            </el-form>
        </div>
    </div>
</template>

<script>

import GridSelectU from '@/components/gridselect/index.vue';
import WangEditor from '@/components/common/wangeditorExercise.vue';
import { EDUKNOWLEDGE, EDUKNOWLEDGE_SEARCH } from '@/utils/constant';
import { get, postJson } from '@/utils/request';

export default {
    components: { WangEditor, GridSelectU },
    props: {
        eduExerciseState: {
            type: String,
            default: 'check'
        },
    },
    watch: {
        'eduExercise.exerciseType':{
            handler(val,oldval){
                if(val != oldval){
                    if(this.eduExerciseState != 'edit'){
                        if(val == 1 || val == 3 || val == 4 || val == 5){
                            this.radio = ""
                        }
                        if(val == 2){
                            this.radio = []
                        }
                    }
                    if(val == 1 || val == 2){
                        this.$nextTick(()=>{
                            for (let i = 0; i < this.radioList.length; i++) {
                                this.$refs['choices' + i][0].init(this.radioList[i].optionContent)
                            }
                        })
                    }else if(val == 4){
                        this.$nextTick(()=>{
                            for (let i = 0; i < this.fillList.length; i++) {
                                this.$refs['fills' + i][0].init(this.fillList[i].fillContent)
                            }
                        })
                    }else if(val == 5){
                        this.$nextTick(()=>{
                            this.$refs.reply.init(this.replyContent)
                        })
                    }
                }
            },immediate: true,
            deep: true
        }
    },
    created() {
        this.getEnumList();
        this.getCategory();
        this.getEduSubjectList();
    },
    data(){
        return{
            rules: {
                id: [{ required: true, message: '不能为空', trigger: 'blur' }],
                exerciseName: [{ required: true, message: '题干不能为空', trigger: 'blur' }],
                categoryId: [{ required: true, message: '题目分类不能为空', trigger: 'blur' }],
                exerciseType: [{ required: true, message: '题目类型', trigger: 'blur' }],
                subjectId: [{ required: true, message: '科目不能为空', trigger: 'blur' }],
                knowledgeIds: [{ required: true, message: '不能为空', trigger: 'blur' }],
                difficulty: [{ required: true, message: '难度程度不能为空', trigger: 'blur' }],
                analysis: [{ required: true, message: '解析不能为空', trigger: 'blur' }],
            },
            radio: "",
            choiceIndex: ["A","B","C","D","E","F","G","H","I","J","K","L","M","N","O","P","Q","R","S","T","U","V","W","X","Y","Z"],
            radioList:[{
                option: "A",
                isAnswer: 0,
                optionContent: '',
            },{
                option: "B",
                isAnswer: 0,
                optionContent: '',
            },{
                option: "C",
                isAnswer: 0,
                optionContent: '',
            },{
                option: "D",
                isAnswer: 0,
                optionContent: '',
            }],
            judge: {
                id: '',
                judge: null,
            },
            fillList:[{
                fillSeq: 1,
                fillContent: ''
            }],
            eduExercise: {
                id: '', //
                exerciseName: '', //题干
                categoryId: '', //题目分类
                exerciseType: 1, //题目类型  1单选 2多选 3判断 4填空 5解答
                subjectId: '', //科目
                knowledgeIds: '', //
                difficulty: '', //难度程度
                analysis: '', //解析
            },
            replyContent: "",
            startCount: [],
            CategoryList: [],
            EDUKNOWLEDGE_code: EDUKNOWLEDGE,
            EDUKNOWLEDGE_search: EDUKNOWLEDGE_SEARCH,
            videoLocationList: [],
            treeProps: {
                children: 'children',
                label: 'categoryName'
            },
            eduSubjectList: [],
            treeProps2: {
                children: 'children',
                label: 'subjectName'
            },
        }
    },
    methods:{
        getEnumList(){
            get(`/edu/utils/getEnum?enumType=exercise_type`).then((res) => {
                if (res.success) {
                    this.videoLocationList = res.enumList;
                }
            });
            get(`/edu/utils/getEnum?enumType=difficulty_level`).then((res) => {
                if (res.success) {
                    this.startCount = res.enumList;
                }
            });
        },
        addKnowledge(){
            this.$refs.gridSelectU1.showSelectDialog();
        },
        addWat(){
            this.$refs.contentEditor.init(this.eduExercise.exerciseName);
            this.$refs.contentEditor1.init(this.eduExercise.analysis);
            for (let i = 0; i < this.radioList.length; i++) {
                // this.$refs['choices' + i].init(this.radioList[i].optionContent)
                this.$refs[('choices' + i)][0].init(this.radioList[i].optionContent);
            }
        },
        addcheck(sign){
            if(sign == "radio"){
                this.radioList.push({
                    option: this.choiceIndex[this.radioList.length],
                    isAnswer: 0,
                    optionContent: '',
                })
                this.$nextTick(()=>{
                    this.$refs['choices' + (this.radioList.length - 1)][0].init("")
                })
            }else if (sign == 'fill'){
                this.fillList.push({
                    fillSeq: this.fillList.length + 1,
                    fillContent: ''
                })
                this.$nextTick(()=>{
                    this.$refs['fills' + (this.fillList.length - 1)][0].init("")
                })
            }
        },
        subcheck(sign, index){
            if(sign == "radio"){
                this.radioList.splice(index, 1);
                this.radioList.forEach((item, index1) => {
                    item.option = this.choiceIndex[index1];
                })
            }else if(sign == 'fill'){
                this.fillList.splice(index, 1);
                this.fillList.forEach((item, index1) => {
                    item.fillSeq = index1 + 1;
                })
            }
        },
        getCategory(){
            get(`/edu/exercisecategory/findAllAsTree`).then((res) => {
                this.loading = false;
                if (res.success) {
                    this.CategoryList = res.treeData;
                }
            });
        },
        getEduSubjectList(query = {}) {
            get(`/edu/subject/findAllAsTree`).then((res) => {
                if (res.success) {
                    this.eduSubjectList = res.treeData;
                }
            });
        },
        getUser(value){
            this.eduExercise.knowledgeIds = value
        },
        init(val){
            this.eduExercise = val;
            console.log(val)
            this.$refs.contentEditor.init(this.eduExercise.exerciseName);
            this.$refs.contentEditor1.init(this.eduExercise.analysis);
            if(this.eduExercise.exerciseType == 1){
                this.radioList = this.eduExercise.choices;
                this.radio = this.eduExercise.choices.find(item => item.isAnswer == 1).option
                for (let i = 0; i < this.radioList.length; i++) {
                    // this.$refs['choices' + i].init(this.radioList[i].optionContent)
                    this.$nextTick(()=>{
                        console.log(this.$refs['choices' + i])
                        this.$refs[('choices' + i)][0].init(this.radioList[i].optionContent)
                    })
                }
            }else if(this.eduExercise.exerciseType == 2){
                this.radioList = this.eduExercise.choices;
                this.radio = this.eduExercise.choices.filter(item => item.isAnswer == 1).map(item => item.option)
                console.log(this.radioList,this.radio)
            }else if (this.eduExercise.exerciseType == 3){
                this.judge = this.eduExercise.judge;
            }else if (this.eduExercise.exerciseType == 4){
                this.fillList = this.eduExercise.fillblanks;
                for (let i = 0; i < this.fillList.length; i++) {
                    this.$nextTick(()=>{
                        this.$refs['fills' + i][0].init(this.fillList[i].fillContent)
                    })
                }
            }else if (this.eduExercise.exerciseType == 5){
                this.replyContent = this.eduExercise.reply.replyContent;
            }
        },
        closeDia(){
            console.log("进来了")
            if(this.eduExercise.exerciseType == 1 || this.eduExercise.exerciseType == 2){
                for (let i = 0; i < this.radioList.length; i++) {
                    // this.$refs['choices' + i].init(this.radioList[i].optionContent)
                    this.$refs[('choices' + i)][0].htmls = "";
                    this.$refs[('choices' + i)][0].displays();
                }
            }
            if(this.eduExercise.exerciseType == 4){
                for (let i = 0; i < this.fillList.length; i++) {
                    // this.$refs['choices' + i].init(this.radioList[i].optionContent)
                    this.$refs[('fills' + i)][0].htmls = "";
                    this.$refs[('fills' + i)][0].displays();
                }
            }
            if(this.eduExercise.exerciseType == 5){
                this.$refs.reply.htmls = "";
                this.$refs.reply.displays();
            }
            this.eduExercise = {
                id: '', //
                exerciseName: '', //题干
                categoryId: '', //题目分类
                exerciseType: 1, //题目类型  1单选 2多选 3判断 4填空 5解答
                subjectId: '', //科目
                knowledgeIds: '', //
                difficulty: '', //难度程度
                analysis: '', //解析
            }
            this.$refs.contentEditor.htmls = "";
            this.$refs.contentEditor1.htmls = "";
            // for (let i = 0; i < this.fillList.length; i++) {
            //     // this.$refs['choices' + i].init(this.radioList[i].optionContent)
            //     this.$refs[('fills' + i)][0].htmls = "";
            // }
            // for (let i = 0; i < this.fillList.length; i++) {
            //     // this.$refs['choices' + i].init(this.radioList[i].optionContent)
            //     this.$refs[('fills' + i)][0].displays();
            // }
            this.radioList = [{
                option: "A",
                isAnswer: 0,
                optionContent: '',
            },{
                option: "B",
                isAnswer: 0,
                optionContent: '',
            },{
                option: "C",
                isAnswer: 0,
                optionContent: '',
            },{
                option: "D",
                isAnswer: 0,
                optionContent: '',
            }];
            this.fillList = [{
                fillSeq: 1,
                fillContent: ''
            }]
            this.radio = "";
            this.replyContent = "";
            this.$refs.contentEditor.displays();
            this.$refs.contentEditor1.displays();
        },
        submit(){
            this.$refs.eduExerciseForm.validate((valid) => {
                this.$refs.eduExerciseForm1.validate((valid1) => {
                    if (valid && valid1) {
                        if(this.eduExercise.exerciseType == 1){
                            this.radioList.forEach((item, index) => {
                                if(item.option == this.radio){
                                    item.isAnswer = 1
                                }else{
                                    item.isAnswer = 0
                                }
                            })
                            this.eduExercise.choices = this.radioList
                        }else if(this.eduExercise.exerciseType == 2){
                            console.log(this.radio,this.radioList)
                            for (let radioListElement of this.radioList) {
                                radioListElement.isAnswer = 0;
                            }
                            this.radio.forEach(option => {
                                const matchingOption = this.radioList.find(item => item.option === option);
                                if (matchingOption) {
                                    matchingOption.isAnswer = 1;
                                }
                            });
                            this.eduExercise.choices = this.radioList
                        }else if(this.eduExercise.exerciseType == 3){
                            this.eduExercise.judge = this.judge;
                        }else if(this.eduExercise.exerciseType == 4){
                            this.eduExercise.fillblanks = this.fillList
                        }else if(this.eduExercise.exerciseType == 5){
                            this.eduExercise.reply = {
                                id: this.eduExercise.reply.id,
                                replyContent: this.replyContent
                            };
                        }
                        let str = '';
                        if(this.eduExerciseState == 'add'){
                            str = `/edu/exercise/addExercise`
                        }else if (this.eduExerciseState == 'edit'){
                            str = `/edu/exercise/editExercise`
                        }
                        postJson(str, { ...this.eduExercise }).then((res)=>{
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                console.log("为什么这个地方没反应")
                                this.$emit('closeDialog', true);
                            }else{
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        })
                    }
                })
            })
        },
    }
};
</script>

<style scoped lang="scss">
[v-cloak] {
    display: none;
}
.pj{
    width: calc((100% - 30px) / 2);
}
</style>